import React, { useEffect, useState, useCallback } from "react";
import { Table, Button, Modal } from "react-bootstrap";
import axios from "axios";
import config from "../../config";
import { toast } from "react-toastify";
import UploadDocModal from "./UploadDocModal";
import { Link } from "react-router-dom";

export default function PurchaseOrderDocumentsPage({ purchaseOrderId }) {
    const [showDocModal, setShowDocModal] = useState(false);
    const [docs, setDocs] = useState([]);
    const [deleteTarget, setDeleteTarget] = useState(null);

    const fetchDocs = useCallback(async () => {
        try {
            const res = await axios.get(`${config.API_BASE_URL}/po-docs/${purchaseOrderId}`);
            setDocs(res.data);
        } catch (err) {
            toast.error("Failed to fetch documents");
        }
    },[purchaseOrderId]);

    useEffect(() => {
        fetchDocs();
    }, [fetchDocs]);

    const handleDelete = async () => {
        try {
            await axios.delete(`${config.API_BASE_URL}/po-docs/${deleteTarget._id}`);
            toast.success("Document deleted");
            fetchDocs();
        } catch (err) {
            toast.error("Failed to delete document");
        }
        setDeleteTarget(null);
    };

    const handleDocUploadSucces = () => {
        setShowDocModal(false);
        fetchDocs()
    }

    return (
        <>
            <div className="d-flex gap-2 flex-wrap justify-content-between align-items-center mb-3">
                <h3>Uploaded Documents</h3>
                <div>
                    <Button variant="warning" onClick={fetchDocs} >
                        <i className="fas fa-refresh" />
                    </Button>
                    <Button variant="info" className="ms-2" onClick={() => setShowDocModal(true)}>
                        Upload Document
                    </Button>
                </div>
            </div>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Document Type</th>
                        <th>Uploaded At</th>
                        <th>File</th>
                        {/* <th>Actions</th> */}
                    </tr>
                </thead>
                <tbody>
                    {docs.length > 0 ? (
                        docs.map((doc) => (
                            <tr key={doc._id}>
                                <td>{doc.documentType || "-"}</td>
                                <td>{new Date(doc.uploadedAt).toLocaleString()}</td>
                                <td>
                                    <Link to={config.DOC_BASE_URL + doc.documentURL} target="_blank" rel="noreferrer">
                                        View
                                    </Link>
                                </td>
                                {/* <td>
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        onClick={() => setDeleteTarget(doc)}
                                    >
                                        Delete
                                    </Button>
                                </td> */}
                            </tr>
                        ))
                    ) : (
                        <tr><td colSpan={4} className="text-center">No documents uploaded</td></tr>
                    )}
                </tbody>
            </Table>

            {/* Delete Confirmation Modal */}
            <Modal show={!!deleteTarget} onHide={() => setDeleteTarget(null)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete document <strong>{deleteTarget?.documentType}</strong>?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setDeleteTarget(null)}>Cancel</Button>
                    <Button variant="danger" onClick={handleDelete}>Delete</Button>
                </Modal.Footer>
            </Modal>

            <UploadDocModal
                show={showDocModal}
                onHide={() => setShowDocModal(false)}
                purchaseOrderId={purchaseOrderId}
                onUpload={handleDocUploadSucces}
            />
        </>
    );
}
